module.exports = __webpack_public_path__ + "img/icon-close-orange.3d679669.svg";